import { t } from 'i18next'

import { GENDER } from 'entities/user/module/index.ts'

import { Passenger } from 'shared/api/MyTicketsModel.ts'
import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList.ts'
import { showWrongDateFormat } from 'shared/lib/dateFormat.ts'

import { listAges, typesDocuments } from '../model.tsx'

export const getPassengerDetails = (selectedPassenger: Passenger) => {
  const passengerDocument = typesDocuments.find(
    (item) => item.name === selectedPassenger?.document?.type,
  )
  const typeAge = listAges.find((item) => item.name === selectedPassenger?.age)

  const optionsGender = [
    { name: GENDER.MALE, option: t('male') },
    { name: GENDER.FEMALE, option: t('female') },
  ]

  return {
    typeAge,
    listDetail: [
      { label: t('last_name'), title: selectedPassenger?.name?.last },
      { label: t('first_name'), title: selectedPassenger?.name?.first },
      {
        label: t('birthdate'),
        title:
          showWrongDateFormat(
            selectedPassenger?.birthdate,
            DATE_FORMAT_LIST.FULL_DATE,
          ) || '',
      },
      {
        label: t('gender'),
        title: optionsGender.find(
          (item) => item.name === selectedPassenger?.gender,
        )?.option,
      },
      { label: t('citizenship'), title: selectedPassenger?.citizenship },
      { label: t('type_passport'), title: passengerDocument?.option || '' },
      {
        label: t('serial_documents'),
        title: selectedPassenger?.document?.original_number,
      },
      {
        label: t('expiration_date'),
        title:
          showWrongDateFormat(
            selectedPassenger?.document?.expire,
            DATE_FORMAT_LIST.FULL_DATE,
          ) || '',
      },
    ],
  }
}
